<div class="relationship-status-grid">
  <app-review-entry label="Relationship Status" i18n-label [value]="relationshipStatus?.type?.name" />
  <app-relationship-effective-date-review-entry [relationshipStatus]="relationshipStatus" />
  <ng-container *ngIf="relationshipStatus?.typeId | relationshipStatusIsPartneredForDisplay">
    <ng-container *ngIf="relationshipStatus?.spouse as spouse">
      <app-review-entry label="Spouse First Name" i18n-label [value]="spouse.firstName" />
      <app-review-entry label="Spouse Last Name" i18n-label [value]="spouse.lastName" />
    </ng-container>
  </ng-container>
</div>
